module.exports = __webpack_public_path__ + "img/toyota.1fe7d480.svg";